import React from 'react';

//Hooks
import {useState, useRef, useEffect, useCallback} from 'react';
import {useSelector} from "react-redux";

//Components
import {Container, Navbar} from "react-bootstrap";
import {ArrowRight} from "react-feather";

//Styles
import Styles from './ScreenHeader.module.scss';

//Utils
import classNames from 'class-names';

const ScreenHeader = ({children}) => {
    const style = useSelector(state => state.widget.style);

    const [isScrollable, setScrollable] = useState(false);
    const [isHidden, setHidden] = useState(false);

    const ref = useRef(null);

    const handleScroll = /* istanbul ignore next */({deltaY}) => {
        setHidden(ref.current.scrollLeft >= ref.current.scrollWidth - ref.current.clientWidth - 15);
        if(window.innerWidth < 992) {
            return;
        }
        ref.current.scrollBy(deltaY, 0);
    };

    useEffect(() => {
        ref.current.addEventListener('wheel', handleScroll);
        ref.current.addEventListener('scroll', handleScroll);

        const container = ref.current;

        return () => {
            container.removeEventListener('wheel', handleScroll);
            container.removeEventListener('scroll', handleScroll);
        };
    }, [ref]);

    const handleResize = useCallback(() => setScrollable(ref.current.scrollWidth > ref.current.clientWidth), [ref]);

    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, [ref, children, handleResize]);

    return (
        <header className={[
            Styles.container,
            style === 'inline' ? Styles.inline : ''
        ].join(' ')}>
            <Navbar className={"position-relative py-0"}>
                <Container ref={ref} className={classNames(Styles.scrollContainer, {[Styles.scrollable]: isScrollable})}>
                    {children}
                </Container>

                {isScrollable && (
                    /* istanbul ignore next */
                    <button className={classNames(Styles.scrollArrow, {[Styles.hidden]: isHidden})} onClick={/* istanbul ignore next */ () => {
                        ref.current.scrollTo({left: ref.current.scrollWidth - ref.current.clientWidth, behavior: 'smooth'});
                        setHidden(true);
                    }}>
                        <ArrowRight size={18} color={'#FFFFFF'}/>
                    </button>
                )}
            </Navbar>
        </header>
    );
};

export default ScreenHeader